
export const FETCH_PRODUCTION_REPORTS_DATA_REQUEST = 'FETCH_PRODUCTION_REPORTS_DATA_REQUEST';
export const FETCH_PRODUCTION_REPORTS_DATA_SUCCESS = 'FETCH_PRODUCTION_REPORTS_DATA_SUCCESS';
export const FETCH_PRODUCTION_REPORTS_DATA_FAILURE = 'FETCH_PRODUCTION_REPORTS_DATA_FAILURE';

export const SET_SUMMARY_GRID_NAME_PRODUCTION_REPORT = 'SET_SUMMARY_GRID_NAME_PRODUCTION_REPORT';

export const CREATE_USER_FORM_PRODUCTION_REPORT = 'CREATE_USER_FORM_PRODUCTION_REPORT';


export const FETCH_PROGRAM_REPORTS_DATA_REQUEST = 'FETCH_PROGRAM_REPORTS_DATA_REQUEST';
export const FETCH_PROGRAM_REPORTS_DATA_SUCCESS = 'FETCH_PROGRAM_REPORTS_DATA_SUCCESS';
export const FETCH_PROGRAM_REPORTS_DATA_FAILURE = 'FETCH_PROGRAM_REPORTS_DATA_FAILURE';

export const CREATE_PRODUCTION_INWARD_REQUEST = 'CREATE_PRODUCTION_INWARD_REQUEST';
export const CREATE_PRODUCTION_INWARD_SUCCESS = 'CREATE_PRODUCTION_INWARD_SUCCESS';
export const CREATE_PRODUCTION_INWARD_FAILURE = 'CREATE_PRODUCTION_INWARD_FAILURE';

export const FETCH_PRODUCTION_REPORT_REJECTQTY_REQUEST = 'FETCH_PRODUCTION_REPORT_REJECTQTY_REQUEST';
export const FETCH_PRODUCTION_REPORT_REJECTQTY_SUCCESS = 'FETCH_PRODUCTION_REPORT_REJECTQTY_SUCCESS';
export const FETCH_PRODUCTION_REPORT_REJECTQTY_FAILURE = 'FETCH_PRODUCTION_REPORT_REJECTQTY_FAILURE';

 export const DELETE_REJECTION_QTY_REQUEST ='DELETE_REJECTION_QTY_REQUEST';
 export const DELETE_REJECTION_QTY_SUCCESS ='DELETE_REJECTION_QTY_SUCCESS';
 export const DELETE_REJECTION_QTY_FAILURE ='DELETE_REJECTION_QTY_FAILURE';

export const FETCH_PRODUCTION_REPORT_INWARD_REQUEST = 'FETCH_PRODUCTION_REPORT_INWARD_REQUEST';
export const FETCH_PRODUCTION_REPORT_INWARD_SUCCESS = 'FETCH_PRODUCTION_REPORT_INWARD_SUCCESS';
export const FETCH_PRODUCTION_REPORT_INWARD_FAILURE = 'FETCH_PRODUCTION_REPORT_INWARD_FAILURE';